"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./ErrorPage.css");
var Text_1 = require("../../components/Text");
var Button_1 = require("../../components/Button");
var Stack_1 = require("../../components/Stack");
var ErrorPage = function (_a) {
  var _b = _a.errorCode,
    errorCode = _b === void 0 ? 404 : _b,
    onClickBack = _a.onClickBack,
    _c = _a.backTextOverride,
    backTextOverride = _c === void 0 ? "Back To Home" : _c,
    messageOverride = _a.messageOverride;
  var err = getErrorDef(errorCode);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    align: "center",
    gap: "large"
  }, {
    children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      size: 16,
      weight: "medium",
      lineHeight: 1.2
    }, {
      children: err.message
    })), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      size: 13,
      color: "secondary",
      lineHeight: 1.2,
      style: {
        textAlign: "center"
      }
    }, {
      children: messageOverride !== null && messageOverride !== void 0 ? messageOverride : err.description
    })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
      type: "primary",
      onClick: onClickBack
    }, {
      children: backTextOverride
    }))]
  }));
};
exports.ErrorPage = ErrorPage;
var getFallbackDef = function (errorCode) {
  return {
    message: "".concat(errorCode, " - Error"),
    description: "Something went wrong."
  };
};
var getErrorDef = function (errorCode) {
  var _a;
  return (_a = errorDict[errorCode]) !== null && _a !== void 0 ? _a : getFallbackDef(errorCode);
};
var errorDict = {
  400: {
    message: "400 - Bad Request",
    description: "There was a problem with your request."
  },
  403: {
    message: "403 - Unauthorized Access",
    description: "The page you are trying to access is unavailable for your account or user type. To access this page, we recommend making sure that you are logged into the correct account or user type."
  },
  404: {
    message: "404 - Page Not Found",
    description: "The requested URL was not found or the page may have been removed."
  },
  405: {
    message: "405 - Method Not Allowed",
    description: "The requested method is inappropriate for this URL"
  },
  500: {
    message: "500 - Internal Server Error",
    description: "A technical problem has prevented this page from loading."
  },
  501: {
    message: "501 - Not Implemented",
    description: "An error has occured. Please check your connection and try again."
  },
  502: {
    message: "502 - Bad Gateway",
    description: "An error has occured. Please check your connection and try again."
  },
  503: {
    message: "503 - Service Unavailable",
    description: "An error has occured. Please try again later."
  },
  504: {
    message: "504 - Gateway Timeout",
    description: "An error has occured. Please check your connection and try again."
  },
  999: {
    message: "This page is under maintenance.",
    description: "The requested page is currently unavailable. Please try again later."
  }
};